import { api } from "../Configurations/axios";
import { CompanyStageFinepModel } from "../Models/CompanyStageFinepModel";
import { LegalEntityRegistrationFinepModel } from "../Models/LegalEntityRegistrationFinepModel";

const GetLegalEntityFinep = async (id: string) => {
    try {
        var result = await api.get(`/LegalEntityRegistrationFINEP/GetLegalEntityRegistrationFINEPByCompanyFINEPId/${id}`);
        var response = result.data;
        return response.data;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const CreateLegalEntityFinep = async (legalEntity: LegalEntityRegistrationFinepModel) => {
    try {
        var result = await api.post(`/LegalEntityRegistrationFINEP/CreateLegalEntityRegistrationFINEP`, legalEntity);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const EditLegalEntityFinep = async (legalEntity: LegalEntityRegistrationFinepModel) => {
    try {
        var result = await api.put(`/LegalEntityRegistrationFINEP/UpdateLegalEntityRegistrationFINEP`, legalEntity);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

interface ValidateLegalEntityFinepProps{
    id: string;
    userEmail: string;
    isContentValid: boolean;
}

const ValidateLegalEntityFinep = async (legalEntity: ValidateLegalEntityFinepProps) => {
    try {
        var result = await api.put(`/LegalEntityRegistrationFINEP/ValidateLegalEntityRegistrationFINEP`, legalEntity);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetLegalEntityFinep,
    CreateLegalEntityFinep,
    EditLegalEntityFinep,
    ValidateLegalEntityFinep
}